/* eslint-disable vue/multi-word-component-names */
import Tabs from "./components/Tabs";
import TabControlsItem from "./components/TabControlsItem";
import TabContentItem from "./components/TabContentItem";

const Plugin = {
  install(app) {
    app.component("Tabs", Tabs);
    app.component("TabControlsItem", TabControlsItem);
    app.component("TabContentItem", TabContentItem);
  },
};

export default Plugin;
